<template>
  <div>
    <h2>Primary Information</h2>
    <div class="memberProfile_Image">
      <img :src="image" class="img-fluid" alt="" />
    </div>
    <div class="text-center">
      <h3>{{ fullname }}</h3>
      <span class="memberCntc">
        <i class="fas fa-envelope"></i>
        {{ personalInfo.email }}
        <valid-icon 
        v-if="personalInfo.is_email_valid !== undefined"
        :is-valid="personalInfo.is_email_valid"
        className="valid-icon"
        />
        <button v-if="isEnrollPrimeGroup" @click="openEmailUpdateModal('member-primary-info')" class="brand-color" style="border:none; background-color:transparent; cursor: pointer; padding: 5px;">
          <i class="fas fa-pencil-alt"></i>
        </button>

      </span>
      <span class="memberCntc">
        <i class="fas fa-phone-alt"></i>
        {{ formattedPhone(personalInfo.phone_1) }}
        <valid-icon 
        v-if="personalInfo.is_phone1_valid !== undefined"
        :is-valid="personalInfo.is_phone1_valid"
        className="valid-icon"
        />
        <button v-if="isEnrollPrimeGroup" @click="openPhoneUpdateModal('member-phone-info')" class="brand-color" style=" border: none; background-color: transparent; cursor: pointer; padding: 5px;">
            <i class="fas fa-pencil-alt"></i>
          </button>
      </span>
    </div>
    <div class="light-bg">
      <div class="memberDetail_lists">
        <ul>
          <!-- <li>
        <span class="strong">Sign Up Date</span>
        <span>: 19-19-2019</span>
      </li> -->
          <li>
            <span class="strong">Gender:</span>
            <span>{{ personalInfo.gender }}</span>
          </li>
          <li>
            <span class="strong">DOB:</span>
            <span>
              {{
                personalInfo.birth_date
                  | date_format('MM/DD/YYYY', 'YYYY-MM-DD')
              }}
            </span>
          </li>
          <li>
            <span class="strong">SSN:</span>
            <span>{{ personalInfo.ssn }}</span>
          </li>
          <li>
            <span class="strong">Phone 1:</span>
            <span>{{ formattedPhone(personalInfo.phone_1) }}</span>
          </li>
          <li>
            <span class="strong">Alt. Phone:</span>
            <span>{{ formattedPhone(personalInfo.phone_2) }}</span>
          </li>
        </ul>
      </div>
    </div>

    <br>
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <h4>Address Information</h4>
      <button @click="openAddressInformationDialog()" class="addBtn" v-if="isEnrollPrimeGroup">
              <i class="fas fa-plus plus-icon"></i>
      </button>
    </div>
    
    <div class="light-bg">
      <div class="memberDetail_lists">
        <ul>
          <li>
            <span class="strong">Street Address:</span>
            <span>
              {{ personalInfo.address ? personalInfo.address.address1 : '' }}
            </span>
          </li>
          <li>
            <span class="strong">Apt/Suite/Other:</span>
            <span>
              {{
                personalInfo.address
                  ? personalInfo.address.address2
                    ? personalInfo.address.address2
                    : 'N/A'
                  : ''
              }}
            </span>
          </li>
          <li>
            <span class="strong">City:</span>
            <span>
              {{ personalInfo.address ? personalInfo.address.city : '' }}
            </span>
          </li>
          <li>
            <span class="strong">State:</span>
            <span>
              {{ personalInfo.address ? personalInfo.address.state : '' }}
            </span>
          </li>
          <li>
            <span class="strong">ZIP Code:</span>
            <span>
              {{ personalInfo.address ? personalInfo.address.zip : '' }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <EmailUpdateModal 
    v-if="isEmailUpdateModalOpen"
    :is-open="isEmailUpdateModalOpen"
    :member-data="personalInfo"
    @close="closeEmailUpdateModal"
    @reloadInfo="reloadInfo"
    />
    <PhoneUpdateModal 
    v-if="isPhoneUpdateModalOpen"
    :is-open="isPhoneUpdateModalOpen"
    :member-data="personalInfo"
    @close="closePhoneUpdateModal"
    @reloadInfo="reloadInfo"
    />
    <AddressInformationModal
    v-if="isAddressInformationModal"
    :is-open.sync="isAddressInformationModal"
    :member-data = "personalInfo"
    :address-info="personalInfo.address_list || []"
    :policyInfo="policyInfo"
    @close ="closeAddressInformationDialog"
    @reloadInfo="reloadInfo"
    />
  </div>
</template>

<script>
import Helper from '@/resource/Helper'
import EmailUpdateModal from '../../pages/Member/modal/EmailUpdateModal.vue'
import PhoneUpdateModal from '../../pages/Member/modal/PhoneUpdateModal.vue'
import AddressInformationModal from './modal/AddressInformationModal.vue'
import isEnrollPrimeGroupUtil from '../../utils/isEnrollPrimeGroupUtil'

export default {
  name: 'PrimaryInfo',
  components: {
    EmailUpdateModal,
    PhoneUpdateModal,
    AddressInformationModal
  },

  props: {
    personalInfo: {
      type: Object,
      required: true,
      default: () => ({})
    },
    image: {
      required: true,
    },
    policyInfo:{
      required:true
    }
  },
  data(){
    return {
      isEmailUpdateModalOpen:false,
      isPhoneUpdateModalOpen:false,
      isAddressInformationModal:false
    }
  },
  methods: {
    reloadInfo() {
      this.$emit('reloadInfo');
    },
    formattedPhone(phone) {
      if (phone) {
        return Helper.formatPhoneNumber(phone)
      }
      return 'N/A'
    },
    openEmailUpdateModal(){
      this.isEmailUpdateModalOpen = true
    },
    closeEmailUpdateModal(){
      this.isEmailUpdateModalOpen = false
    },
    openPhoneUpdateModal(){
      this.isPhoneUpdateModalOpen = true
    },
    closePhoneUpdateModal(){
      this.isPhoneUpdateModalOpen = false
    },
    openAddressInformationDialog(){
      this.isAddressInformationModal = true
    },
    closeAddressInformationDialog(){
      this.isAddressInformationModal = false
    }
  },
  computed: {
    fullname() {
      if (this.personalInfo) {
        let personalInfo = this.personalInfo
        let middleName =
          personalInfo.middle_name !== null ? personalInfo.middle_name : ''
        return `${personalInfo.first_name} ${middleName} ${personalInfo.last_name}`
      }
      return ''
    },
    isEnrollPrimeGroup() {
      return isEnrollPrimeGroupUtil.isEnrollPrimeGroup();
    }
  },
}
</script>
<style>
.addBtn{
  background: #03c3ec;
  border: 0;
  outline: none;
  color: #fff;
  border-radius: 40px;
  display: flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
}
.plus-icon {
  position: relative;
  font-size: 16px;
}

.plus-icon::after {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 4px;
  height: 4px;
  background-color: white;
  border-radius: 50%;
}
</style>
